export default __webpack_public_path__ + "media/images/paylogos/color/visa-0381d5c9b8a07a9303f5443c8a1588a0.png";